import { Capabilities } from './capabilities';

interface AdditiveCapabilitiesOperations {
  communicate: boolean;
  manage: boolean;
  read: boolean;
}

export type AdditiveOperation = keyof AdditiveCapabilitiesOperations;

export type AdditiveCapabilitiesAware<T extends string = 'capabilities'> = {
  [key in T]: AdditiveCapabilities;
};

export class AdditiveCapabilities implements Capabilities, AdditiveCapabilitiesOperations {
  public get isDenyAll(): boolean {
    return !this.read && !this.communicate && !this.manage;
  }

  public get isReadOnly(): boolean {
    return this.read && !this.communicate && !this.manage;
  }

  /** Operations rank from weakest to strongest */
  private static rank: AdditiveOperation[] = ['read', 'communicate', 'manage'];

  public read = false;
  public communicate = false;
  public manage = false;

  public static create(maxLevel: AdditiveOperation): AdditiveCapabilities {
    const capabilities = new AdditiveCapabilities();
    const upperBoundaryIndex: number = this.rank.indexOf(maxLevel);

    // operations are additive = stronger includes weaker
    // e.g. if one can 'communicate' he can 'read' as well, but not 'manage'
    this.rank.forEach((operation, i) => {
      if (i <= upperBoundaryIndex) {
        capabilities[operation] = true;
      } else {
        capabilities[operation] = false;
      }
    });

    return capabilities;
  }
}
